"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Hashtable_1 = require("../../Collections/HashMap/Hashtable");
var XmlAttributes = /** @class */ (function () {
    /**
     *
     */
    function XmlAttributes(attrs) {
        var _this = this;
        if (attrs === void 0) { attrs = null; }
        this._attributes = new Hashtable_1.default();
        if (attrs) {
            attrs.forEach(function (element) { return _this._attributes.put(element[0], element[1]); });
        }
    }
    XmlAttributes.prototype.toJSON = function () {
        return this._attributes.toJSON();
    };
    XmlAttributes.prototype.clone = function () {
        // let temp = new Hashtable<string, string>();
        // this._attributes.entries.forEach(element => {
        //     temp.put(element[0], element[1]);
        // });
        return new XmlAttributes(this._attributes.entrySet());
    };
    Object.defineProperty(XmlAttributes.prototype, "length", {
        get: function () {
            return this._attributes.length;
        },
        enumerable: false,
        configurable: true
    });
    XmlAttributes.prototype.keys = function () {
        return this._attributes.keys();
    };
    XmlAttributes.prototype.getIndex = function (AttrName) {
        return this._attributes.keys().indexOf(AttrName);
    };
    XmlAttributes.prototype.getValue = function (sAttrName) {
        return this._attributes.get(sAttrName);
    };
    XmlAttributes.prototype.setValue = function (attrName, value) {
        this._attributes.put(attrName, value);
        this[attrName] = value;
    };
    XmlAttributes.prototype.deleteAttribute = function (attrName) {
        this._attributes.delete(attrName);
    };
    XmlAttributes.prototype.clearAll = function () {
        this._attributes.clear();
    };
    return XmlAttributes;
}());
exports.default = XmlAttributes;

//# sourceMappingURL=XmlAttributes.js.map
